import React, { useState, useRef } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import Package from './Package'
import Payment from './Payment';
//import "bootstrap/dist/css/bootstrap.min.css";
import bootstrap from './bootstrap/scss/bootstrap.scss';
import "bootstrap-icons/font/bootstrap-icons.css";

const CheckOut = props => {

  const [packageId,setPackageId] = useState();

  return (
    <Container className="local-bootstrap">
      <Row>
        <Col lg={6}>
           <Package setPackage={e=>setPackageId(e)} />
        </Col>
        <Col lg={6}>
        <Payment package={packageId} />
        </Col>
      </Row>
    </Container>
  )
}

export default CheckOut
